module.exports = __webpack_public_path__ + "img/neirong_guanli.c720fd03.png";